import { render, staticRenderFns } from "./MoleculeEditionMapPathTreeNodeActionsComments.vue?vue&type=template&id=0bf224ac&"
import script from "./MoleculeEditionMapPathTreeNodeActionsComments.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionMapPathTreeNodeActionsComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports